import { pmFetchJson, pmFetchJsonResult, type PmFetchJsonResult } from "@penmate/react-shared/api/pmFetch";
import type { RawMessage } from "@/api/messages";

type LetterShowResponse = { letter: RawMessage };
type LetterSendResponse = { letter: RawMessage; user?: any; errors?: any; error?: any; payment_error?: any };

export const normalizeLetterFromApi = (raw: any): RawMessage => {
  const data = raw && raw.data && typeof raw.data === "object" ? raw.data : {};
  return { ...data, ...raw };
};

export async function fetchLetter(args: { letterId: string }): Promise<RawMessage> {
  const res = await pmFetchJson<LetterShowResponse>(`/letters/${encodeURIComponent(args.letterId)}`, {
    method: "GET",
  });
  return normalizeLetterFromApi(res.letter);
}

export async function sendLetter(args: { letterId: string }): Promise<PmFetchJsonResult<LetterSendResponse>> {
  const res = await pmFetchJsonResult<LetterSendResponse>(`/letters/${encodeURIComponent(args.letterId)}/send`, {
    method: "POST",
    body: {},
  });
  if (res.data && (res.data as any).letter) {
    (res.data as any).letter = normalizeLetterFromApi((res.data as any).letter);
  }
  return res;
}

export async function confirmLetterPayment(args: {
  letterId: string;
  intent_id: string;
  payment_method: string;
  client_secret: string;
}): Promise<PmFetchJsonResult<{ letter: RawMessage; errors?: any; error?: any }>> {
  const res = await pmFetchJsonResult<{ letter: RawMessage; errors?: any; error?: any }>(
    `/letters/${encodeURIComponent(args.letterId)}/send/confirm-payment`,
    {
      method: "POST",
      body: {
        intent_id: args.intent_id,
        payment_method: args.payment_method,
        client_secret: args.client_secret,
      },
    },
  );
  if (res.data && (res.data as any).letter) {
    (res.data as any).letter = normalizeLetterFromApi((res.data as any).letter);
  }
  return res;
}
